import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { LoginPage } from '../login/login';

//@IonicPage()
@Component({
  selector: 'page-reactivateotp',
  templateUrl: 'reactivateotp.html',
})
export class ReactivateotpPage {
  private vistor_react : FormGroup;
  accesscode= "";
  otp ="";

  validation_messages = {
    'accesscode': [],//['', Validators.required],
    'otp': [
      { type: 'required', message: '*Please enter otp.' },
    ],
  }


  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,  
    private formBuilder: FormBuilder,
    private toastCtrl: ToastController, 
    public http: HttpClient,    
    public actionSheetCtrl: ActionSheetController, 
    public platform: Platform, 
    public loadingCtrl: LoadingController ,
    public global: GlobalProvider ) {
    this.vistor_react = this.formBuilder.group({
      accesscode: [null],//['', Validators.required],
      otp: ['', Validators.required]
    });

    this.accesscode = this.navParams.get('accesscode');
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad ResetpwdPage');
  }

  goback(){
    this.navCtrl.pop();
  }
  
  verifyOTP(){
    (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=true;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json'
      })
    };

    let postData = JSON.stringify({
      "activateDTO": {
        "otpValue": this.otp,
        "verificationCode": this.accesscode
      }
    });

    

    console.log('--------------');
    console.log(postData);

    
    
    this.http.post(this.global.baseUrl+"api/admin/activate", postData, httpOptions)
      .subscribe((data:any) => {
        console.log(data['_body']);
        console.log(data);
        console.log(data.error);
        if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
            
          }else{
            if(data.errorList.length == 0){
              let toast = this.toastCtrl.create({
                message: data.message,
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });
  
              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();
              (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
              this.navCtrl.push(LoginPage);
            }else{
              let toast = this.toastCtrl.create({
                message: 'Visitor activated successfully!.',
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });
  
              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();
              (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
              
              this.navCtrl.push(LoginPage);
            }
            
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 3000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/reactivateotp/reactivateotp.ts